"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _schema = _interopRequireDefault(require("../schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _schema["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/ics/dist/pipeline/validate.js
// module id = 587
// module chunks = 14